import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { MedicationList } from '@/modules/shared/components/medication-list/MedicationList'

import type { MedicationSchemeStatus, MedicationStatement } from '@/modules/app/types/HealthParameter.types'

type MedicationAnswerProps = {
  title: string
  description: string
  medications: MedicationStatement[]
  schemeStatus?: MedicationSchemeStatus
}

export const MedicationAnswer = ({ title, description, medications, schemeStatus }: MedicationAnswerProps) => {
  const theme = useTheme()

  return (
    <FlexColumn gap={theme.UI.Spacing.Space2}>
      <Span type='BodyMediumBold' color={theme.Colors.Neutrals.Darkest}>
        {`${title && description ? `${title}: ` : title || ''}${description}`}
      </Span>
      <MedicationList medications={medications} schemeStatus={schemeStatus} />
    </FlexColumn>
  )
}
